import { Spin as AntdSpin } from "antd";

import { SPIN_TEST_ID } from "./constants";
import type { SpinProps } from "./types";

/**
 * A spinner for displaying loading state of a page or a section.
 */
const Spin = ({ "data-testid": testId, ...restOfTheProps }: SpinProps) => (
  <AntdSpin data-testid={testId ?? SPIN_TEST_ID} {...restOfTheProps} />
);

export { Spin };
